import { CommandMessage } from '@tableau/api-internal-contract-js';
import { UINamespaceHandler } from '../common-bootstrap/UINamespaceHandler';

export class DesktopUINamespaceHandler implements UINamespaceHandler {
  /**
   * On desktop, all commands are handled by the normal ApiDispatcher.
   */
  public tryHandleCommand(msg: CommandMessage): boolean {
    return false;
  }
}
